
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Mutation, Action, Getter } from "vuex-class";
import { ActivityLogDTO } from "../../store/activity-log/types";
import { formatDateMixin } from "@/mixins";
import vSelect from "vue-select";
import { Datetime } from "vue-datetime";

const ActivityLog = namespace("activityLog");
const Eventqueue = namespace("eventqueue");

Vue.mixin(formatDateMixin);

@Component({
	components: {
		"v-select": vSelect,
		Datetime
	}
})
export default class ActivityLogPopup extends Vue {
	@Eventqueue.Mutation setActivityLogShown: any;
	@Action fetchUserGroups: any;
	@ActivityLog.Action addActivityLog: any;
	@Getter("getUserGroups") groups: any;
	@ActivityLog.Action getActivityLogOutcomes: any;
	@ActivityLog.Action editActivityLog: any;

	private ActivityLogData: ActivityLogDTO = {
		activityLogID: 0,
		eventTypeID: null,
		logged: new Date().toISOString(),
		start: new Date().toISOString(),
		end: new Date().toISOString(),
		categoryID: null,
		categoryTitle: null,
		areaID: null,
		areaTitle: null,
		viewedUserID: null,
		outcomeNote: null,
		userTitle: null,
		hiddenFromUsers: false
	};

	private TimeZone = "UTC";

	private AreaData = [];

	private CategoryData = [];

	private error = "";

	public async mounted() {
		this.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		await this.fetchUserGroups();
		this.AreaData = this.groups;
	}

	private setSelectedCategory(category) {
		this.ActivityLogData.categoryID = category.eventOutcomeID;
		this.ActivityLogData.categoryTitle = category.title;
	}

	private async setSelectedArea(area) {
		this.ActivityLogData.areaID = area.groupID;
		this.ActivityLogData.areaTitle = area.title;

		this.CategoryData = [];

		await this.getActivityLogOutcomes(area.groupID).then(result => {
			this.CategoryData = result.data;
		});
	}

	private PreselectedGroupId() {
		//TO DO decide how we are going to preselect the default value
		// let groupIds = this.groups.map(o => o.groupID);
		// let min = Math.min.apply(Math, groupIds);
		// return this.groups.find(groups => groups.groupID == min);
	}

	public get ActivityLogIsValid() {
		return (
			this.ActivityLogData &&
			this.ActivityLogData.areaID &&
			this.ActivityLogData.outcomeNote
		);
	}

	private async UpdateActivityLog(activityLog: ActivityLogDTO) {
		this.error = "";

		// bit of a hack to get around some weirdness with Axios post where it was unsetting the values being sent
		let newobj: ActivityLogDTO = {
			activityLogID: activityLog.activityLogID,
			start: activityLog.start,
			end: activityLog.end,
			categoryID: activityLog.categoryID,
			areaID: activityLog.areaID,
			outcomeNote: activityLog.outcomeNote,
			eventTypeID: 11,
			logged: new Date(),
			hiddenFromUsers: false,
			categoryTitle: activityLog.categoryTitle,
			areaTitle: activityLog.areaTitle,
			viewedUserID: 0,
			userTitle: activityLog.userTitle
		};

		Object.keys(newobj).forEach(function(key,index) {
			if(newobj[key] == null)
			{
				delete newobj[key];
			}
		});

		if (!newobj.areaID || newobj.areaID == 0) {
			this.error = "Please select an area for this activity log entry";
		} else if (!newobj.outcomeNote || newobj.outcomeNote == "") {
			this.error = "Please enter some notes for this Activity Log entry";
		} else {
			await this.addActivityLog(newobj).then(result => {
				this.error = "Activity Logged";
				this.resetEditRowObject();

				setTimeout(()=>{
					this.error = null;
					this.setActivityLogShown(false);
				},1500)
			});
		}
	}

	private resetEditRowObject() {
		this.ActivityLogData.activityLogID = 0;
		this.ActivityLogData.eventTypeID = null;
		this.ActivityLogData.logged = new Date().toISOString();
		this.ActivityLogData.start = new Date().toISOString();
		this.ActivityLogData.end = new Date().toISOString();
		this.ActivityLogData.categoryID = null;
		this.ActivityLogData.categoryTitle = null;
		this.ActivityLogData.areaID = null;
		this.ActivityLogData.areaTitle = null;
		this.ActivityLogData.viewedUserID = null;
		this.ActivityLogData.outcomeNote = null;
		this.ActivityLogData.hiddenFromUsers = false;

		this.CategoryData = [];
	}

	public cancel() {
		this.resetEditRowObject();
		this.setActivityLogShown(false);
	}

	private get GetTimeNow(){
		return new Date().toISOString();
	}

	private setTime(event, field){
		let time = event.target.value;
		let dateTime = new Date();

		let hoursMins = time.split(":");

		dateTime.setHours(hoursMins[0]);
		dateTime.setMinutes(hoursMins[1]);

		let startTime = dateTime.toISOString();

		this.ActivityLogData[field] = startTime;
	}
}
